import React,{useState,useEffect} from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import {useAuthUser} from 'react-auth-kit'
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';






const Editsale = (props) => {

  const navigate = useNavigate();
  const auth = useAuthUser();  
 
useEffect( () => {



    allclient();

}, []); 


const [client, setClient] = useState([]);


const allclient = async () => {
  

  try {
    const username =  auth().username;
    const key = auth().key;
    
    axios.get(`https://diamond.future-swift.com/api/client.php?key=`+key+'&username='+username)
    .then(res => {
     
      setClient(res.data.productlist.productdata);
    })
  } catch (error) { throw error;}    

}




 
 
  const [saleinfo, setSaleinfo] = useState({
    client: props.list.client,
    price: props.list.price,
    count: props.list.count,
    status: props.list.status,
    paid: props.list.paid,
    note: props.list.note,
    receipt:props.list.receipt,
  
  });
  const onChangeValue = (e) => {
    setSaleinfo({
      ...saleinfo,
      [e.target.name]:e.target.value
    });
  } 

  const [check,setCheck]= useState(Number(saleinfo.status));

  
  const onChangeValue1 = (e) => {
    setSaleinfo({
      ...saleinfo,
      [e.target.name]:e.target.value
    });
  
    const value = e.target.value
   
  
    if(value==='0') {
      setCheck(0);
     }else{
      setCheck(1);
     } 
  
  } 


  const [date, setDate] = useState(new Date(props.list.date)); 
  // Inserting a new user into the Database.
  const updatesale = async(event) => {
    try {
      event.preventDefault();
      event.persist();
    
      var formData = new FormData();
     
      formData.append("sale_id", props.list.sale_id); 
      formData.append("client",saleinfo.client); 
      
      formData.append("price",saleinfo.price); 
      formData.append("count",saleinfo.count);  
      formData.append("total",Number(saleinfo.price)*Number(saleinfo.count)); 
      formData.append("status",saleinfo.status); 
      formData.append("paid",saleinfo.paid); 
      formData.append("date",format(date, 'yyyy-MM-dd')); 
      formData.append("note",saleinfo.note); 
      formData.append("receipt",saleinfo.receipt); 
      formData.append("username",auth().username); 
      formData.append("key",auth().key); 

      axios.post(`https://diamond.future-swift.com/api/editsale.php`, formData )
      .then(res => {
        console.log(res.data);
        navigate(`/mysale`);
        return;
       })
    } catch (error) { throw error;}    
  };


 
const options =[
  {value:"", label:"Choose..."},
  {value:"1", label:"نقد"},
  {value:"0", label:"اجل"},

];


  







return (
  <div>  
 
 <form className="insertForm" onSubmit={updatesale}>
    <h1> تعديل البيع </h1>

    
    

  <label htmlFor="_client">حساب العميل</label> 
  <br /> 
  {client.length > 0 ?  <select id='_client' name='client' onChange={onChangeValue} required>
    
        {client.map(option => (
         option.value === saleinfo.client ?
        <option selected key={option.value} value={option.value}>
            {option.label}
          </option>
          :<option  key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      :<select id='_emp' className='select' name='employee' defaultValue='o' onChange={onChangeValue} required>
    <option value='' selected> لا يوجد عميل </option>
    </select>
}
   

    
   
    <br /> <br />
    <label htmlFor="_price">السعر</label>
    <input
      type="number"
      id="_price"
      name="price"
      onChange={onChangeValue}
      value={saleinfo.price}
      placeholder="Enter Price"
      autoComplete="off"
      required
    />
    <br /> <br />
    <label htmlFor="_count">العدد</label>
    <input
      type="number"
      id="_count"
      name="count"
      min={1}
      value={saleinfo.count}
      onChange={onChangeValue}
      placeholder="Enter Count"
      autoComplete="off"
      required
    />


          


   
           
     
          <br /> <br />
    <label htmlFor="_total">الأجمالي</label>
    <input
    readOnly
      type="number"
      id="_total"
      name="total"
      value={Number(saleinfo.price)*Number(saleinfo.count)}
      onChange={onChangeValue}
      placeholder="Enter Total"
      autoComplete="off"
      required
    />
    <br /> <br />
    <label htmlFor="_status">عملية الدفع</label> 
    <br /> 
    <select id='_status' name='status' defaultValue={saleinfo.status} onChange={onChangeValue1} required>

        {options.map(option => (
          <option  key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    
   
    <br /> <br />
    
    {check ===0 ? <div>
    <label htmlFor="_paid">الوارد</label>
    <br /> 
  <input
      type="number"
      id="_paid"
      name="paid"
      
      value={props.list.status<1?  saleinfo.paid:null }
      min={0}
      onChange={onChangeValue}
      placeholder="Enter paid"
      autoComplete="off"
      required
    />
   
   </div>
:
    ""
}


    <br /> <br />
    <DatePicker  selected={date} onChange={(date) =>   
setDate(date)}
dateFormat="yyyy-MM-dd" 

required

/> 
<br /> <br />
<div dir='rtl' className="flex">
   <label htmlFor="_receipt"> السند</label>
  <input
  style={{width:'30%'}}
      type=""
      id="_receipt"
      name="receipt"
      value={saleinfo.receipt}
      onChange={onChangeValue}
      placeholder="Receipt no."
      autoComplete="off"

    />
   
   <label htmlFor="_note"> ملاحظة</label>
  <textarea
  style={{width:'60%'}}
      type=""
      id="_note"
      name="note"
    value={saleinfo.note}
      onChange={onChangeValue}
      placeholder="Optional"
      autoComplete="off"
    
    />

    </div>
    <br /> 
    <input type="submit" value="حفظ" />
  </form>
  </div>
);
};

export default Editsale;